/*
 *
 * History constants
 *
 */

enum ActionTypes {
  HISTORY_UNDO = 'app/CONFIGURATOR/HISTORY_UNDO_REQUEST',
  HISTORY_UNDO_SUCCESS = 'app/CONFIGURATOR/HISTORY_UNDO_SUCCESS',
  HISTORY_UNDO_FAILURE = 'app/CONFIGURATOR/HISTORY_UNDO_FAILURE',
  HISTORY_REDO = 'app/CONFIGURATOR/HISTORY_REDO_REQUEST',
  HISTORY_REDO_SUCCESS = 'app/CONFIGURATOR/HISTORY_REDO_SUCCESS',
  HISTORY_REDO_FAILURE = 'app/CONFIGURATOR/HISTORY_REDO_FAILURE',
  HISTORY_ADD_STEP = 'app/CONFIGURATOR/HISTORY_ADD_STEP',
}

export default ActionTypes;
